const cht = {
  locale: 'zh-HK',
  messages: {
    "共{count}家店": "共 {count} 家店"
  }
}


export default cht